<template>
    <div class="header">
        <div class="pre-actions">
            <ActionButton v-if="close_route"
                @click="onActionClose()"
                class="back"
                icon="fas fa-chevron-circle-left"
                v-tooltip='"global.actions.back"'
            />
        </div>

        <h2 class="title">
            {{Language.say(props.title)}}
        </h2>

        <div class="actions">
            <slot name="actions"> </slot>
            <slot name="actions_over"> </slot>
        </div>

    </div>

    <slot name="pre_content"></slot>

    <main :class='content_class' class="content"> 
        <slot
          name="content"
        >
        </slot>
    </main>
</template>

<script setup>
  import {defineProps } from "vue";
  import router         from "@/vue/router";
  import ActionButton   from '@/vue/Elements/Buttons/ActionButton.vue';
  import Language       from '@/js/Shared/Language/Language.js';

  const props = defineProps({
    title : {
      default : '',
    },

    content_class : {
      default: 'content',
    },

    close_route : {
      default : ''
    },
  })

  const onActionClose = () => {
    router.push({name: props.close_route});
  };
</script>